import { render, staticRenderFns } from "./ModalCriterio5.vue?vue&type=template&id=7c2130b6&scoped=true"
import script from "./ModalCriterio5.vue?vue&type=script&lang=js"
export * from "./ModalCriterio5.vue?vue&type=script&lang=js"
import style0 from "./ModalCriterio5.vue?vue&type=style&index=0&id=7c2130b6&prod&scoped=true&lang=css"
import style1 from "./ModalCriterio5.vue?vue&type=style&index=1&id=7c2130b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2130b6",
  null
  
)

export default component.exports